import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./nujobsdashboardrecentlyviewed.scss";

import { Card, Statistic } from "antd";

import {
  EnvironmentOutlined,
  ClockCircleOutlined,
  DollarOutlined,
  EyeOutlined
} from "@ant-design/icons";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import useNuJobsStore from "../../../store/nujobs.store";

function NuJobsRecentlyViewed() {

  const navigate = useNavigate();
  const { nujobGetMyViewdJobs,ViewedJobs,totalViewedCount,ViewedResponseMetadata,nujobsSetSelectedJD } = useNuJobDetailsStore();   
  const { setSearchMetaData } = useNuJobsStore(); 
  const source = "viewed"  
  
  function formatUnixDate(ts) {
      const d = new Date(ts * 1000);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();

      return `${dd}-${mm}-${yyyy}`;
  }   
  const encodeJson = () =>{
        let encodedJsonValues ={};
        encodedJsonValues.keywords= "";
        encodedJsonValues.city=null;
        encodedJsonValues.category=null;  
        encodedJsonValues.timestamp= 0;  
        encodedJsonValues.postingdate= "All"
        encodedJsonValues.pagenum= 1;
        encodedJsonValues.maxPerPage= 10;

        //from values
        encodedJsonValues.minexp=null;
        encodedJsonValues.maxexp=null;  
        encodedJsonValues.minctc= null;  
        encodedJsonValues.maxctc= null
        encodedJsonValues.noticeperiod= []; 
        encodedJsonValues.postingdate=[];
        encodedJsonValues.workmode=null;  
        encodedJsonValues.diversity= null;  
        encodedJsonValues.role= []
        encodedJsonValues.roletype= []
        encodedJsonValues.companytype= null
        encodedJsonValues.jobfor= null  

        const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
        encodedJsonValues.nujuid= userData.nujuid   
        encodedJsonValues.nujoid= userData.nujoid
        encodedJsonValues.signedin= true
        encodedJsonValues.pendingsync = JSON.parse(
                    localStorage.getItem("NuJobsPendingSync") || "[]"
            );                
                           
        return encodedJsonValues
    }
  
  useEffect(() => {
    const jasonValues = encodeJson()
    nujobGetMyViewdJobs(jasonValues,null)
  }, []);


  const jobsData =
    ViewedJobs?.map((job, idx) => ({
      id: idx + 1,
      title: job?.JDDetails.Title,
      location:job?.JDRequired.WorkLocation[0],
      role: job?.JDRequired?.role,
      salary: job?.JDProject.MinCtc + " - "+job?.JDProject.MaxCtc + " LPA",
      experience:job?.JDRequired.MinExperience + " - " + job?.JDRequired.MaxExperience + " Yrs",
      keywords: job?.JDRequired.kwarray,
      companyName: job?.JDClient.ClientName,
      jobid: job?.QhCompanyJID,
      AddedOn: formatUnixDate(job?.timestamp),
    })) || [];

  const handleViewMoreClick = () => {
    setSearchMetaData(ViewedResponseMetadata)
    navigate("/nujobshome/nujobsViewedJobsSearchResults");
  }

  const jdHandler = (id) => {
    navigate(`/nujobshome/nujobsViewJobsContainer/viewed/${id}`);
  };
  return (
    <div className="nujobsdashboardrecentlyviewed-wrapper">

      <div className="section-header">
        <div>
          <h3>Recently Viewed Jobs</h3>
          <span>
            Jobs viewed by you in last 7 days.
          </span>
        </div>
          {jobsData.length > 0 && (
            <div
              className="view-all-link"
              onClick={handleViewMoreClick}
            >
              View All →
            </div>
          )}         
      </div>     
      <div className="recent-jobs-section">
        <div className="recent-jobs-grid">
          {jobsData.slice(0, 3).map((job,idx) => (
            <div className="recent-job-card" key={job.id}>

              <div className="job-top">
                <div>
                  <div className="job-title">
                    {job.title}
                  </div>

                  <div className="company-name">
                    {job.company}
                  </div>
                </div>

                <div className="view-icon">
                  <EyeOutlined />
                </div>
              </div>

              <div className="job-meta">

                <div className="meta-item">
                  <EnvironmentOutlined />
                  {job.location}
                </div>

                <div className="meta-item">
                  <ClockCircleOutlined />
                  {job.experience}
                </div>

                <div className="meta-item">
                  <DollarOutlined />
                  {job.salary}
                </div>

              </div>

              <div className="job-footer">

                <div className="viewed-time">
                  {job.jobid}
                </div>

                <button className="view-job-btn" onClick={()=>jdHandler(job.jobid)}>
                  View Job
                </button>

              </div>

            </div>
          ))}
        </div>

      </div>

    </div>
  );
}

export default NuJobsRecentlyViewed;